import { Component, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColDef } from 'ag-grid-community';
import { ApiService } from '../../shared/services/api.service';
import { NewUserComponent } from './new-user/new-user.component';

@Component({
  standalone: false,
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss'
})
export class UsersComponent {

  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  content: any;
  type = 'currency';
  apiUrl: any;

  columnDefs: ColDef[] = [
        {
      headerName: 'Action',
      field: 'action',
      width: 150,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-outline-primary', 'ps-4', 'pe-4', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye"></i>';
        button.addEventListener('click', () => this.onEdit(params));
        return button;
      },
    },
     {
      headerName: 'Status',
      field: 'status',
      editable: false,
      filter: true,
    },

    {
      headerName: 'Name',
      field: 'name',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Email Id',
      field: 'email',
      editable: false,
      filter: true,
      width: 250
    },
    {
      headerName: 'Mobile No',
      field: 'mobile',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Department',
      field: 'department',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Role',
      field: 'role',
      editable: false,
      filter: true,
    },
   
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };


  constructor(
    private _modal: NgbModal,
    private _api: ApiService,
    private zone: NgZone
  ) { }

  ngOnInit(): void {

  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {

      vm.gridApi.sizeColumnsToFit();
    }
    this.gridApi.sizeColumnsToFit();
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        // vm.apiUrl = '/users/v1/list';
         this.apiUrl = '/users/v1/list' + '?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            params.successCallback(res.data, res.count);
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onAddNew() {
    const vm = this;
    const modalRef = vm._modal.open(NewUserComponent, {
      backdrop: "static",
      size: "lg",
    });
    modalRef.componentInstance.onSave.subscribe(() => {
      vm.gridApi.refreshInfiniteCache();
    });
  }

  onEdit(data: any) {
    const vm = this;
    vm.zone.run(() => {
      const modalRef = vm._modal.open(NewUserComponent, {
        backdrop: "static",
        size: "lg",
      });
      modalRef.componentInstance.newUser = data.data;
      modalRef.componentInstance.onSave.subscribe(() => {
        vm.gridApi.refreshInfiniteCache();
      });
    });
  }

}
